var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c("v-card-title", { staticClass: "text-h6 mb-4" }, [
        _vm._v(" Warnings for " + _vm._s(_vm.typeName) + " "),
      ]),
      _vm.warnings
        ? _c(
            "v-card-text",
            { staticClass: "text-body-1" },
            [
              _vm.has("messages")
                ? _c("v-simple-table", {
                    staticClass: "mb-4",
                    attrs: { dense: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function () {
                            return [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", { staticClass: "text-center" }, [
                                    _vm._v("Messages"),
                                  ]),
                                ]),
                              ]),
                              _c(
                                "tbody",
                                [
                                  _vm._l(
                                    _vm.warnings.messages.l,
                                    function (message, index) {
                                      return _c("tr", { key: index }, [
                                        _c("td", [_vm._v(_vm._s(message.msg))]),
                                      ])
                                    }
                                  ),
                                  _vm.warnings.messages.more > 0
                                    ? _c("tr", [
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(_vm.warnings.messages.more) +
                                              " more messages"
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2185640985
                    ),
                  })
                : _vm._e(),
              _vm.has("solverErrors")
                ? _c("v-simple-table", {
                    staticClass: "mb-4",
                    attrs: { dense: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function () {
                            return [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [_vm._v("Problem")]),
                                  _c("th", [_vm._v("Message")]),
                                ]),
                              ]),
                              _c(
                                "tbody",
                                [
                                  _vm._l(
                                    _vm.warnings.solverErrors.l,
                                    function (warning, index) {
                                      return _c("tr", { key: index }, [
                                        _c("td", [
                                          _vm._v(_vm._s(warning.probName)),
                                        ]),
                                        _c("td", [_vm._v(_vm._s(warning.msg))]),
                                      ])
                                    }
                                  ),
                                  _vm.warnings.solverErrors.more > 0
                                    ? _c("tr", [
                                        _c("td", { attrs: { colspan: "2" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.warnings.solverErrors.more
                                            ) + " more solver errors"
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2659508803
                    ),
                  })
                : _vm._e(),
              _vm.has("infeasibleConstraints")
                ? _c("v-simple-table", {
                    staticClass: "mb-4",
                    attrs: { dense: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function () {
                            return [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [_vm._v("Problem")]),
                                  _c("th", [_vm._v("Infeasible Constraint")]),
                                ]),
                              ]),
                              _c(
                                "tbody",
                                [
                                  _vm._l(
                                    _vm.warnings.infeasibleConstraints.l,
                                    function (constraint, index) {
                                      return _c("tr", { key: index }, [
                                        _c("td", [
                                          _vm._v(_vm._s(constraint.probName)),
                                        ]),
                                        _c("td", [
                                          _c("details", [
                                            _c("summary", [
                                              _vm._v(
                                                _vm._s(constraint.constraint)
                                              ),
                                            ]),
                                            _vm._v(" Variables involved: "),
                                            _c(
                                              "ul",
                                              { staticClass: "pa-0" },
                                              _vm._l(
                                                constraint.variables.l,
                                                function (variable, varIndex) {
                                                  return _c(
                                                    "li",
                                                    { key: varIndex },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(variable) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            constraint.variables.more > 0
                                              ? _c("div", [
                                                  _vm._v(
                                                    " And " +
                                                      _vm._s(
                                                        constraint.variables
                                                          .more
                                                      ) +
                                                      " more variables "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]),
                                        ]),
                                      ])
                                    }
                                  ),
                                  _vm.warnings.infeasibleConstraints.more > 0
                                    ? _c("tr", [
                                        _c(
                                          "td",
                                          { attrs: { colspan: "100%" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.warnings
                                                    .infeasibleConstraints.more
                                                ) +
                                                " more infeasible constraints "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      826693274
                    ),
                  })
                : _vm._e(),
              _vm.has("suspiciousResults")
                ? _c("v-simple-table", {
                    attrs: { dense: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function () {
                            return [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [_vm._v("Message")]),
                                  _c("th", [_vm._v("Value")]),
                                ]),
                              ]),
                              _c(
                                "tbody",
                                [
                                  _vm._l(
                                    _vm.warnings.suspiciousResults.l,
                                    function (issue, index) {
                                      return _c("tr", { key: index }, [
                                        _c("td", [_vm._v(_vm._s(issue.msg))]),
                                        _c("td", [
                                          _c("details", [
                                            _c("summary", [
                                              _vm._v(
                                                _vm._s(issue.value) +
                                                  " " +
                                                  _vm._s(issue.unit)
                                              ),
                                            ]),
                                            _vm._v(
                                              " Expected value around " +
                                                _vm._s(
                                                  Math.round(issue.interval[0])
                                                ) +
                                                " and " +
                                                _vm._s(
                                                  Math.round(issue.interval[1])
                                                ) +
                                                " (" +
                                                _vm._s(issue.reference) +
                                                "). "
                                            ),
                                          ]),
                                        ]),
                                      ])
                                    }
                                  ),
                                  _vm.warnings.suspiciousResults.more > 0
                                    ? _c("tr", [
                                        _c("td", { attrs: { colspan: "2" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.warnings.suspiciousResults
                                                .more
                                            ) + " more suspicious results"
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1999308999
                    ),
                  })
                : _vm._e(),
            ],
            1
          )
        : _c("v-card-text", [_vm._v(" No warnings ")]),
      _c(
        "v-card-actions",
        [
          _c(
            "v-btn",
            {
              attrs: { text: "", color: "red darken-1" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { color: "primary", text: "" },
              on: { click: _vm.handleReRun },
            },
            [_vm._v(" Run again ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }